import React, { Component } from 'react'
import './PerformanceRow.css'

class CalYearPerfRow extends Component {
  formatPercent(number) {
    return number !== null ? `${parseFloat(number * 100).toFixed(2)}%` : '-'
  }

  formatDate(string) {
    return new Date(string).toLocaleDateString([], { timeZone: 'UTC' })
  }
  render() {
    const { fund } = this.props

    if (fund.calYearPerformance === null) {
      return null
    }

    const length = fund.calYearPerformance.values.length

    return (
      <tr className='greyline'>
        <td width='70' className='textLeft'>
          {(() => {
            switch (fund.type) {
              case 'BMK':
                return fund.ticker.toUpperCase();
              case 'BLEND':
              case 'COD':
                return '-';
              default:
                const url = fund.fundPageURL || fund.msUrl;
                return (
                  <a className='tickerLink' href={url} target='_new'>
                    {fund.ticker}
                  </a>
                );
            }
          })()}
        </td>
        {['BMK', 'WTIDX'].includes(fund.type) ? (
          <td width='300' className='textLeft'>
            {fund.name.replace(/&amp;/g, '&')}
          </td>
        ) : (
          <td width='300' className='textLeft'>
            {`${fund.name.replace(/&amp;/g, '&')} (NAV)`}
          </td>
        )}
        <td className='textCenter'> {this.formatDate(fund.inceptionDate)} </td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 12]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 12])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 11]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 11])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 10]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 10])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 9]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 9])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 8]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 8])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 7]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 7])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 6]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 6])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 5]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 5])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 4]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 4])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 3]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 3])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 2]) ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 2])}</td>
        <td className='textCenter'>{isNaN(fund.calYearPerformance.values[length - 1]) || fund.calYearPerformance.values[length - 1] === 0 ? '-' : this.formatPercent(fund.calYearPerformance.values[length - 1])}</td>
      </tr>
    )
  }
}

export default CalYearPerfRow
